// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26yCG","label":"styles_label__12PEf"};